export const DEFAULT = {
    company: '유타몰',
    tel: '02) 925-9999',
    tel_text: '문의전화',
    address: '서울시 성북구 동소문로 106 (동선동 1가)',
    address_text: '오시는 길',
    ceo: '하용락',
    parking: '유타몰 주차장 안내',
    more: '자세히 보기',
    notice: '공지사항',
    map: '유타몰 위치',
}

export const D_CONTENTS = [
    {
        id: '1',
        title: 'Experience the Difference',
        desc: '삶의 유토피아 유타몰에서 찾으세요'
    },
    {
        id: '2',
        title: 'Experience the Difference',
        desc: '성북의 랜드마크 복합 라이프스타일 쇼핑몰'
    },
]

export const NAV = [
    {
        id: '1',
        title: '유타몰소개',
        link: '/sub01',
    },
    {
        id: '2',
        title: '유타몰안내',
        link: '/sub02',
        submenu: [
            {
                id:'01',
                title: '공지사항',
                link: '/sub02/notice',
            },
            {
                id:'02',
                title: '공개입찰',
                link: '/sub02/bid',
            },
        ]
    },
    {
        id: '3',
        title: '층별안내',
        link: '/sub03',
    },
    {
        id: '2',
        title: '오시는길',
        link: '/sub04',
    },
]

export const SECTION = [
    {
        id: '1',
        title: 'About Uta Mall',
    },

    {
        id: '2',
        title: 'More Information',
    },

]

export const BRAND_ITM = [
    {
        id: 1,
        title: '성북의 중심 랜드마크',
        number: 'SINCE 2009년',
        desc: '2009년 쇼핑몰 오픈부터 지금까지, 앞으로도 지역과 함께 성장하는 유타쇼핑몰이 되겠습니다.'
    },
    {
        id: 2,
        title: '복합 문화 쇼핑몰',
        number: '총 16층',
        desc: '지하 2층부터 14층까지 총 16층 복합 문화 쇼핑몰, 편리한 주차시설을 제공합니다.'
    },
    {
        id: 3,
        title: '초역세권 쇼핑몰',
        number: '초역세권 4호선',
        desc: '지하철 4호선 성신여대입구역과 연결되어 있는 초역세권 복합 문화 쇼핑몰입니다.'
    },
]

export const CGV = [
    {
        id: 1,
        title: '영화 그 이상의 감동',
        desc: 'CGV는 선진화된 관람문화와 최고의 서비스로 고객에게 잊을 수 없는 감동을 선사합니다.'
    }
]

export const NOTICE = {
    title: 'Notice',
    content: [
        { id: 1, subject: '2023년 설 연휴 유타몰 매장 휴무 안내', date: '2023.01.18' },
        { id: 2, subject: '2022년 설 연휴 유타몰 매장 휴무 안내', date: '2022.02.11' },
        { id: 3, subject: '2021년 추석 연휴 유타몰 휴무 안내', date: '2022.02.11' },
        { id: 4, subject: '2021년 설 연휴 유타몰 매장 휴무 안내', date: '2022.02.11' },
        { id: 5, subject: '신종 코로나 사태 관련 방역 조치 완료 안내', date: '2022.02.11' },
    ]
}

export const FOOTER = {
    service: [
        { title: '온라인 고객 서비스-02)925-9999' },
        { title: '상호-(주)유타몰' },
        { title: '대표자 성명-하용락' },
        { title: '서울시 성북구 동소문로 106(동선동 1가)' },
        { title: '사업자등록번호-186-81-00211' },
    ],
}

export const UTA_MALL_P = [
    {
        title: '삶의 유토피아 유타몰에서 찾으세요.',
        desc: '지하철 4호선 성신여대입구역과 연결되어 있는 초역세권 복합 문화 쇼핑몰입니다. 유타몰은 기존 주변 상권 내 경험하지 못한, 문화, 쇼핑, 엔터테인먼트, 헬스장과 의료시설이 한곳에서 어우러진 새로운 패러다임의 문화 라이프스타일의 시너지를 선보입니다. 지하 2층부터 14층까지 총 16층의 합리적이고 트렌드 한 복합 문화 쇼핑 공간, 그리고 편리한 주차시설을 제공하며 더불어, 유타몰은 성북 상권과의 어울림을 생각합니다.'
    },
    {
        title: '성북의 랜드마크 문화, 패션, 건강, 생활 복합 라이프스타일 쇼핑몰',
        desc: '달콤한 팝콘 냄새가 풍기는 "문화", 그 이상의 감동을 즐길 수 있는 영화관. 최신 "패션" 트렌드의 흐름을 선도하는 의류 매장. "건강"과 "생활"을 함께 관리할 수 있는 헬스장과 동서의학이 공존하는 최신 의료시설들. 또한, 일상의 즐거움과 행복을 더하는 엔터테인먼트로 차별화된 경험을 제공합니다. 성북의 중심 랜드마크 유타몰은 2009년 쇼핑몰 오픈부터 지금까지, 앞으로도 지역과 함께 성장하는 유타쇼핑몰이 되겠습니다.'
    }
]

export const TOTAL_PARK = [
    {
        id: '1',
        title: '문의전화',
        desc: '02-925-9999',
    },
    {
        id: '2',
        title: '총 주차 대수',
        desc: '187대',
    },
    {
        id: '3',
        title: '주차요금 부과 기준',
        desc: '기본 30분 3,000원 이후 10분당 500원 부과',
    },
]

